'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _Calls = require('../../../../../../../Calls');

var _Calls2 = _interopRequireDefault(_Calls);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CallsRow = (_temp2 = _class = function (_PrismaCmsComponent) {
  _inherits(CallsRow, _PrismaCmsComponent);

  function CallsRow() {
    var _temp, _this, _ret;

    _classCallCheck(this, CallsRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PrismaCmsComponent.call.apply(_PrismaCmsComponent, [this].concat(args))), _this), _this.callUser = function (userId, roomId) {
      var callUser = _this.context.callUser;
      return callUser(userId, {
        room: roomId
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CallsRow.prototype.updateCall = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee2(data) {
      var _this2 = this;

      var _context, client, updateCallProcessor, id, variables;

      return _regenerator2.default.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return');

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee2, this);
    }));

    function updateCall(_x) {
      return _ref.apply(this, arguments);
    }

    return updateCall;
  }(); // callUser


  CallsRow.prototype.componentDidUpdate = function componentDidUpdate() {
    _PrismaCmsComponent.prototype.componentDidUpdate && _PrismaCmsComponent.prototype.componentDidUpdate.call(this);
  };

  CallsRow.prototype.render = function render() {
    var _this3 = this;

    var _context4 = this.context,
        streams = _context4.streams,
        connections = _context4.connections;

    var _props = this.props,
        ChatRoom = _props.ChatRoom,
        callRequests = _props.data.objects,
        other = _objectWithoutProperties(_props, ['ChatRoom', 'data']);

    if (!ChatRoom) {
      return null;
    }

    var currentUser = this.context.user;

    if (!currentUser || !callRequests) {
      return null;
    }

    return _PrismaCmsComponent.prototype.render.call(this, _react2.default.createElement(_Calls2.default, {
      ChatRoom: ChatRoom // key={activeCall}
      // key={dialogueId}
      ,
      user: currentUser // where={{
      //   // callId: activeCall,
      //   id: dialogueId,
      // }}
      ,
      callUser: this.callUser,
      streams: streams,
      connection: connections ? connections[0] : null,
      closeCall: function closeCall(event) {
        return _this3.closeCall();
      },
      callRequests: callRequests
    }));
  };

  return CallsRow;
}(_component2.default), _class.propTypes = {
  // item: PropTypes.object.isRequired,
  ChatRoom: _propTypes2.default.object.isRequired,
  data: _propTypes2.default.object.isRequired
}, _temp2);
exports.default = CallsRow;
module.exports = exports['default'];